import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListaPropostas from '../ListaPropostas/ListaPropostas';



class ListaPropostasImplantadas extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {

    return (
      <ListaPropostas history={this.props.history}/>
    );

  }

}

ListaPropostasImplantadas.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasImplantadas);